/**
 * @fileoverview Project caller-owned hierarchy into column-based navigation. Selection and context callbacks connect visible folders/files to the workspace's actions; this layout owns no data fetching or persistence. `DocumentFileExplorerController.js` coordinates shared explorer behavior and the parent owns canonical hierarchy.
 */

import React, { forwardRef } from 'react';
import './MillerColumnExplorer.css';



function classNames(...values) {
  return values.filter(Boolean).join(' ');
}



const MillerColumnExplorer = forwardRef(function MillerColumnExplorer({
  className = '',
  children,
  ...props
}, ref) {
  return (
    <div ref={ref} className={classNames('miller-columns', className)} {...props}>
      {children}
    </div>
  );
});



export const MillerColumn = forwardRef(function MillerColumn({
  active = false,
  category = false,
  uploadTarget = false,
  className = '',
  children,
  ...props
}, ref) {
  return (
    <section
      ref={ref}
      className={classNames(
        'miller-column',
        active && 'is-active',
        category && 'is-categories',
        uploadTarget && 'is-upload-drop-target',
        className
      )}
      {...props}>
      {children}
    </section>
  );
});



export function MillerColumnHeader({ className = '', children, ...props }) {
  return (
    <header className={classNames('miller-column__header', className)} {...props}>
      {children}
    </header>
  );
}



export function MillerColumnList({
  uploadTarget = false,
  className = '',
  children,
  ...props
}) {
  return (
    <div
      className={classNames(
        'miller-column__list',
        uploadTarget && 'is-upload-drop-target',
        className
      )}
      {...props}>
      {children}
    </div>
  );
}



export function MillerColumnRow({
  as: Element = 'div',
  selected = false,
  file = false,
  dropTarget = false,
  uploadTarget = false,
  className = '',
  children,
  ...props
}) {
  return (
    <Element
      className={classNames(
        'miller-column__row',
        selected && 'is-selected',
        file && 'is-file',
        dropTarget && 'is-drop-target',
        uploadTarget && 'is-upload-drop-target',
        className
      )}
      {...props}>
      {children}
    </Element>
  );
}



export function MillerColumnItem({
  as: Element = 'button',
  className = '',
  children,
  ...props
}) {
  const elementProps = Element === 'button' && props.type === undefined
    ? { ...props, type: 'button' }
    : props;
  return (
    <Element className={classNames('miller-column__item', className)} {...elementProps}>
      {children}
    </Element>
  );
}



export function MillerColumnEmpty({ className = '', children, ...props }) {
  return (
    <div className={classNames('miller-column__empty', className)} {...props}>
      {children}
    </div>
  );
}

export default MillerColumnExplorer;
